(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canny-collar-size-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root) return;

    var input = root.querySelector('.canny-size-finder__input');
    var unitButtons = root.querySelectorAll('[data-unit]');
    var calcBtn = root.querySelector('[data-action="calc"]');
    var resetBtn = root.querySelector('[data-action="reset"]');
    var resultWrap = root.querySelector('.canny-size-finder__result');
    var resultEl = root.querySelector('[data-result]');
    var noteEl = root.querySelector('[data-note]');

    var rangesEl = root.querySelector('[data-ranges]');
    var ranges;
    try {
      ranges = JSON.parse(rangesEl.textContent);
    } catch (e) {
      console.error('Canny size finder: invalid ranges JSON', e);
      return;
    }

    var unit = 'cm';

    function setUnit(nextUnit) {
      unit = nextUnit;
      unitButtons.forEach(function (b) {
        var active = b.getAttribute('data-unit') === unit;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function parseNumber(v) {
      var cleaned = String(v || '').trim().replace(',', '.');
      cleaned = cleaned.replace(/[^0-9.\-]/g, '');
      var n = Number(cleaned);
      return Number.isFinite(n) ? n : null;
    }

    function inchesToCm(inches) { return inches * 2.54; }

    function findSizeByCm(cm) {
      // inclusive ranges + ordered list => boundary chooses the smaller size
      for (var i = 0; i < ranges.length; i++) {
        var r = ranges[i];
        if (cm >= r.min && cm <= r.max) return r;
      }
      return null;
    }

    function showResult(text, note) {
      resultEl.textContent = text;
      noteEl.textContent = note || '';
      resultWrap.hidden = false;
    }

    function hideResult() {
      resultWrap.hidden = true;
      resultEl.textContent = '';
      noteEl.textContent = '';
    }

    function calculate() {
      hideResult();

      var n = parseNumber(input.value);
      if (n === null) return showResult('Please enter a number.', 'Example: 34.5');
      if (n <= 0) return showResult('Please enter a neck size greater than zero.');

      var cm = (unit === 'cm') ? n : inchesToCm(n);
      var cmDisplay = Math.round(cm * 10) / 10;

      var match = findSizeByCm(cm);
      if (!match) {
        var min = ranges[0].min;
        var max = ranges[ranges.length - 1].max;
        return showResult('No match found.', 'Converted: ' + cmDisplay + 'cm. Chart covers ' + min + '–' + max + 'cm.');
      }

      var boundaryNote = '';
      for (var i = 1; i < ranges.length; i++) {
        var boundary = ranges[i].min;
        if (Math.abs(cm - boundary) < 1e-9) {
          boundaryNote = ' You’re exactly between sizes (' + boundary + 'cm). We usually recommend the smaller size for the best fit.';
          break;
        }
      }

      var baseNote = (unit === 'in') ? ('That’s about ' + cmDisplay + 'cm.') : ('Measured: ' + cmDisplay + 'cm.');
      showResult(match.label, baseNote + boundaryNote);
    }

    unitButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        setUnit(b.getAttribute('data-unit'));
        hideResult();
        input.focus();
      });
    });

    calcBtn.addEventListener('click', calculate);

    resetBtn.addEventListener('click', function () {
      input.value = '';
      setUnit('cm');
      hideResult();
      input.focus();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') calculate();
    });

    setUnit('cm');
  }

  document.querySelectorAll('[data-canny-size-finder]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();
})();
